import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Process, ProcessSearchCommand } from '../../models/Process';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ProcessProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/processes';

  searchProcesses(command: ProcessSearchCommand): Observable<ApiResponse<Process[]>> {
    return this.httpClient.post<ApiResponse<Process[]>>(`${this.baseUrl}/search`, command);
  }
}
